// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"127b8307","195":"127b8307","229":"cd457be2","323":"127b8307","327":"127b8307","441":"127b8307","534":"127b8307","653":"127b8307","722":"127b8307","851":"d057229d","997":"127b8307"}[chunkId] + ".chunk.css";
};